import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, catchError, throwError } from 'rxjs';
import * as ErrorActions from '../../+state/notifications/notifications.actions';
import * as AuthActions from '../../auth/store/actions/auth.actions';
import { Notification } from '../../+state/notifications/models/notification.interface';

export enum ErrorTypes {
  GetErrorHeader = 'getErrorHeader',
  PostErrorHeader = 'postErrorHeader',
  PatchErrorHeader = 'patchErrorHeader',
  DeleteErrorHeader = 'deleteErrorHeader',
  AppErrorHeader = 'appErrorHeader',
}

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private _exceptedPaths = [
    'signin',
    'validate',
  ];

  constructor(
    private readonly _store: Store,
    private readonly _translate: TranslateService,
  ) { }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const header = this._getErrorHeader(request.method);
        const { url } = request;
        const urlInExceptions = this._exceptedPaths.some(path => url.includes(path));
        let errorMessage: string;

        if (error.status === 401) {
          return throwError(() => error);
        }

        if (error.status === 404 && url.includes('profile')) {
          this._store.dispatch(AuthActions.logout());
        }

        if (error.status === 0) {
          errorMessage = this._translate.instant('error.timeout');
        } else {
          errorMessage = error?.error?.error?.message || this._translate.instant('error.defaultText');
        }

        if (!urlInExceptions) {
          const notification: Notification = {
            type: 'danger',
            title: header,
            message: errorMessage,
            createdAt: new Date(),
          };

          this._store.dispatch(
            ErrorActions.addNotification({ notification }),
          );
        }

        return throwError(() => error);
      }),
    );
  }

  private _getErrorHeader(method: string): string {
    switch (method) {
      case 'GET': return this._translate.instant(ErrorTypes.GetErrorHeader);
      case 'POST': return this._translate.instant(ErrorTypes.PostErrorHeader);
      case 'DELETE': return this._translate.instant(ErrorTypes.DeleteErrorHeader);
      case 'PATCH': return this._translate.instant(ErrorTypes.PatchErrorHeader);
      default: return this._translate.instant(ErrorTypes.AppErrorHeader);
    }
  }
}
